import styled, { css } from 'styled-components'
import { colors } from '@styles/theme'
import { above } from '@styles/mixins/breakpoints'
import Logo from '@icons/LogoIcon.inline.svg'
import { SH3, SH4, SParagraph } from '@components/Typography'
import { SWideButton } from '@components/Benefits/Card'

export const SCard = styled.div`
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  box-sizing: border-box;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 227px;
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${above('md')(css`
    padding: 40px;
  `)}

  ${above('xl')(css`
    margin-bottom: 0;
    margin-right: 20px;
    width: 580px;

    &:last-of-type {
      margin-right: 0;
    }
  `)}
`

export const STitleBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SLogoContainer = styled.div`
  background: ${colors.white};
  border-radius: 50%;
  box-shadow: 0 5px 12px rgba(204, 203, 203, 0.2);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  margin-right: 20px;

  ${above('md')(css`
    width: 80px;
    height: 80px;
    margin-right: 32px;
  `)}
`

export const SLogo = styled(Logo)`
  width: 25px;
  height: 25px;

  ${above('md')(css`
    width: 42px;
    height: 42px;
  `)}
`

export const STitle = styled(SH3)`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  padding-top: 6px;

  ${above('md')(css`
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    padding-top: 0;
    align-self: flex-start;
  `)}
`

export const SText = styled(SParagraph)`
  font-size: 14px;
  line-height: 20px;
  margin-left: 68px;

  ${above('md')(css`
    font-size: 16px;
    line-height: 24px;
    margin-left: 112px;
    margin-top: -30px;
    width: 64%;
  `)}
`

export const SButton = styled(SWideButton)`
  margin-top: auto;
  white-space: nowrap;

  &:hover {
    border-color: ${colors.darkBlue};
    background-color: ${colors.darkBlue};
  }

  ${above('md')(css`
    margin-top: 16px;
    margin-left: 112px;
    width: 192px;
  `)}
`

export const SAddressesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  ${above('md')(css`
    margin-left: 112px;
    margin-top: -30px;
  `)}

  ${above('xl')(css`
    margin-left: 112px;
    margin-top: -30px;
    max-width: 300px;
  `)}
`

export const SAddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${above('md')(css`
    margin-bottom: 32px;
  `)}
`

export const SAddressTitle = styled(SH4)`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;

  ${above('md')(css`
    font-size: 16px;
    line-height: 24px;
  `)}
`

export const SAddress = styled(SText)`
  margin-bottom: 8px;
  margin-left: 0;
  width: 100%;

  ${above('md')(css`
    margin-top: 0;
  `)}
`

export const SOpeningHours = styled(SAddress)`
  margin-bottom: 0;
`
